import React from 'react'
import './css/services.css'
import seo1 from './images/seo1.png'
import seo2 from './images/seo2.png'
import seo3 from './images/seo3.png'
import seo4 from './images/seo4.png'
import seo5 from './images/seo5.png'
import seo6 from './images/seo6.png'
import seo7 from './images/seo7.png'
import seo8 from './images/seo8.png'
import seo9 from './images/seo9.png'
import seo10 from './images/seo10.png'
import seo11 from './images/seo11.png'
import seo12 from './images/seo12.png'
import seo13 from './images/seo13.png'
import seo14 from './images/seo14.png'


export default function Seo_marketing_ser() {
  return (
    <>
      <div className="seo-main">
    <div className="seo-main-heading">
      <h1>Our Professional SEO Services</h1>
    </div>
      <div className="seo-main-para">
        <p>At Raj Digital Marketing, we offer SEO services that are custom-built around your business goals, industry, and audience. Using the latest trends, tools, and data-driven techniques, we help you rise in search rankings, attract qualified traffic, and succeed in today’s competitive digital landscape.</p>
      </div>
      </div>
      <div className="container marketing-services-main">
        <div className="row row-cols-2 marketing-services-sub">
            <div className="col seo-marketing-col">
                <div className="marketing-img"><img src={seo1} alt="" /></div>
            </div>
            <div className="col seo-marketing-col">  
            <div className="heading-content-seo-mar">
                        <h1>
                        Keyword Research & Strategy 
                        </h1>
                    </div>
                    <div className="side-para3">
                        <p>Effective SEO starts with choosing the right keywords and that’s where our expertise comes in. We dive deep into how your audience searches, combining your input with advanced keyword research tools and competitive analysis. Whether you're targeting long-tail search terms or refining mobile-specific queries, we build a custom keyword strategy tailored to your niche and goals. Our process ensures your site ranks for the terms that matter most driving high-quality traffic and better visibility where it counts.</p>
                        </div>
                        <div className="heading-button">
                        <div className="button-design-seo-mar">
                            <h4>View More</h4>
                        </div>
                    </div>
            </div>
            <div className="col seo-marketing-col">
            <div className="heading-content-seo-mar">
                        <h1>
                        On-Page Optimization
                        </h1>
                    </div>
                    <div className="side-para3">
                        <p>Your website’s success starts with what’s on the page. With over 75% of users never scrolling past the first search results page, on-page SEO is more critical than ever. At Raj Digital Marketing, we fine-tune every on-page element  from content structure and meta tags to internal linking and mobile responsiveness. Our approach ensures your website not only ranks better in search engines but also delivers a smoother, more engaging experience for your visitors.</p>
                        </div>
                        <div className="heading-button">
                        <div className="button-design-seo-mar">
                            <h4>View More</h4>
                        </div>
                    </div>
            </div>
            <div className="col seo-marketing-col">
                <div className="marketing-img"><img src={seo2} alt="" /></div>
            </div>
             <div className="col seo-marketing-col">
                <div className="marketing-img"><img src={seo3} alt="" /></div>
            </div>
            <div className="col seo-marketing-col">
            <div className="heading-content-seo-mar">
                        <h1>
                        Off-Page Optimization
                        </h1>
                    </div>
                    <div className="side-para3">
                        <p>Off-page SEO plays a vital role in improving your website’s credibility and search rankings, with nearly half of Google’s ranking factors tied to off-site signals. At Raj Digital Marketing, we go beyond your website to build a strong digital footprint. From earning high-quality backlinks to managing your brand reputation, leveraging social signals, and creating shareable content, our off-page SEO strategies are designed to increase visibility, trust, and overall domain authority.</p>
                        </div>
                        <div className="heading-button">
                        <div className="button-design-seo-mar">
                            <h4>View More</h4>
                        </div>
                    </div>
            </div>
            <div className="col seo-marketing-col">
            <div className="heading-content-seo-mar">
                        <h1>
                        Technical SEO
                        </h1>
                    </div>
                    <div className="side-para3">
                        <p>Technical SEO focuses on the behind-the-scenes elements that directly impact your site’s search engine rankings. With nearly 40% of websites struggling due to technical issues, our expert team ensures your website is technically sound. From improving site speed to ensuring mobile compatibility and fixing crawl errors, we provide thorough technical audits and on-site optimizations that boost your site’s visibility and make it easier for search engines to index your content.</p>
                        </div>
                        <div className="heading-button">
                        <div className="button-design-seo-mar">
                            <h4>View More</h4>
                        </div>
                    </div>
            </div>
            
            <div className="col seo-marketing-col">
                <div className="marketing-img"><img src={seo4} alt="" /></div>
            </div>
            <div className="col seo-marketing-col">
                <div className="marketing-img"> <img src={seo5} alt="" /></div>
            </div>
            <div className="col seo-marketing-col">
            <div className="heading-content-seo-mar">
                        <h1>
                        E-commerce SEO
                        </h1>
                    </div>
                    <div className="side-para3">
                        <p>E-commerce SEO is essential for online stores aiming to rank higher and convert more visitors. With nearly 46% of shoppers starting their product search on Google, having your products show up first matters. At Raj Digital Marketing, we tailor SEO strategies specifically for e-commerce businesses — from optimizing product pages and categories to enhancing mobile and voice search performance. We also offer seamless marketplace integrations, including Walmart, and implement email marketing strategies to boost retention and deliver a personalized shopping experience that keeps customers coming back.</p>
                        </div>
                        <div className="heading-button">
                        <div className="button-design-seo-mar">
                            <h4>View More</h4>
                        </div>
                    </div>
            </div>
            <div className="col seo-marketing-col">
            <div className="heading-content-seo-mar">
                        <h1>
                        Link Building
                        </h1>
                    </div>
                    <div className="side-para3">
                        <p>Backlinks remain one of the strongest ranking factors in SEO—but it’s all about quality, not just quantity. At Raj Digital Marketing, we understand the importance of earning trusted, relevant links. With most websites having fewer than ten backlinks, and over half of marketers finding link building the toughest part of SEO, our dedicated team steps in with proven, white-hat strategies. Through strong industry connections and local SEO efforts, we help increase your website's authority, visibility, and credibility in search engine results—safely and effectively.</p>
                        </div>
                        <div className="heading-button">
                        <div className="button-design-seo-mar">
                            <h4>View More</h4>
                        </div>
                    </div>
            </div>
            
            <div className="col seo-marketing-col">
                <div className="marketing-img"><img src={seo6} alt="" /></div>
            </div>
            <div className="col seo-marketing-col">
                <div className="marketing-img"><img src={seo7} alt="" /></div>
            </div>
            <div className="col seo-marketing-col">
            <div className="heading-content-seo-mar">
                        <h1>
                        Local SEO
                        </h1>
                    </div>
                    <div className="side-para3">
                        <p>With over 86% of consumers searching for local businesses online, strong local SEO is essential. At Raj Digital Marketing, we help you stand out in your target area by optimizing your Google Business Profile and improving your visibility in local search results. Whether you're a brick-and-mortar store or a service provider, our local SEO strategies are designed to attract high-intent customers nearby driving more foot traffic, calls, and conversions right from your community.</p>
                        </div>
                        <div className="heading-button">
                        <div className="button-design-seo-mar">
                            <h4>View More</h4>
                        </div>
                    </div>
            </div>
            <div className="col seo-marketing-col">
            <div className="heading-content-seo-mar">
                        <h1>
                        Franchise SEO
                        </h1>
                    </div>
                    <div className="side-para3">
                        <p>Managing SEO for multiple business locations requires a tailored approach. At Raj Digital Marketing, we specialize in Franchise SEO—developing location-specific strategies that help each branch rank higher in local searches. From publishing geo-targeted content to optimizing local listings and running localized ad campaigns, we ensure your entire franchise benefits from increased visibility, traffic, and conversions. Let each location thrive with the power of customized SEO.</p>
                        </div>
                        <div className="heading-button">
                        <div className="button-design-seo-mar">
                            <h4>View More</h4>
                        </div>
                    </div>
            </div>
            
            <div className="col seo-marketing-col">
                <div className="marketing-img"><img src={seo8} alt="" /></div>
            </div>
            <div className="col seo-marketing-col">
                <div className="marketing-img"><img src={seo9} alt="" /></div>
            </div>
            <div className="col seo-marketing-col">
            <div className="heading-content-seo-mar">
                        <h1>
                        Website Analysis
                        </h1>
                    </div>
                    <div className="side-para3">
                        <p>At Raj Digital Marketing, our website analysis services go beyond the surface. We conduct an in-depth audit of your site’s structure, speed, technical setup, and on-page elements to identify issues that could be limiting your search engine visibility. With nearly 40% of websites suffering from technical SEO errors, a thorough analysis is critical. Our experts detect and fix these problems, ensuring your website performs optimally and aligns with the latest search engine standards to boost rankings and user experience.</p>
                        </div>
                        <div className="heading-button">
                        <div className="button-design-seo-mar">
                            <h4>View More</h4>
                        </div>
                    </div>
            </div>
            <div className="col seo-marketing-col">
            <div className="heading-content-seo-mar">
                        <h1>
                        Competitor Analysis
                        </h1>
                    </div>
                    <div className="side-para3">
                        <p>At Raj Digital Marketing, we believe that knowing your competitors is key to beating them. That’s why our SEO competitor analysis services dive deep into your industry landscape—evaluating the top players, their keyword strategies, backlink profiles, and content performance. With over 67% of marketers prioritizing competitor insights in their SEO efforts, this analysis becomes a powerful tool. By identifying gaps and opportunities, we craft a tailored SEO strategy that helps your business rise above the competition and capture a greater share of online visibility.</p>
                        </div>
                        <div className="heading-button">
                        <div className="button-design-seo-mar">
                            <h4>View More</h4>
                        </div>
                    </div>
            </div>
            
            <div className="col seo-marketing-col">
                <div className="marketing-img"><img src={seo10} alt="" /></div>
            </div>
            <div className="col seo-marketing-col">
                <div className="marketing-img"><img src={seo11} alt="" /></div>
            </div>
            <div className="col seo-marketing-col">
            <div className="heading-content-seo-mar">
                        <h1>
                        AI SEO Services
                        </h1>
                    </div>
                    <div className="side-para3">
                        <p>At Raj Digital Marketing, we leverage cutting-edge AI SEO solutions to drive smarter, faster, and more accurate results. Artificial Intelligence helps us analyze user intent, search patterns, and algorithm updates in real time—allowing us to make data-backed decisions that improve your site’s performance. With over 73% of marketers planning to increase their use of AI in SEO, and businesses seeing up to a 50% boost in results, AI is reshaping how SEO works. Our AI-powered strategies deliver enhanced keyword targeting, content optimization, and ranking improvements that keep you ahead in the evolving digital landscape.</p>
                        </div>
                        <div className="heading-button">
                        <div className="button-design-seo-mar">
                            <h4>View More</h4>
                        </div>
                    </div>
            </div>
            <div className="col seo-marketing-col">
            <div className="heading-content-seo-mar">
                        <h1>
                        Voice Search Optimization
                        </h1>
                    </div>
                    <div className="side-para3">
                        <p>As more users turn to voice assistants for quick answers, voice search optimization has become essential for SEO success. With over 52% of people using voice search while driving and 70.4% of top-performing voice search pages secured with HTTPS, it's clear that optimizing for voice queries enhances both visibility and trust. At Raj Digital Marketing, we implement advanced voice search SEO strategies—focusing on natural language, question-based keywords, and mobile-first design—to ensure your website is easily discoverable by voice assistants. Our tailored SEO for voice search helps your brand stay accessible and competitive in the voice-driven digital landscape.</p>
                        </div>
                        <div className="heading-button">
                        <div className="button-design-seo-mar">
                            <h4>View More</h4>
                        </div>
                    </div>
            </div>
            
            <div className="col seo-marketing-col">
                <div className="marketing-img"><img src={seo12} alt="" /></div>
            </div>
            <div className="col seo-marketing-col">
                <div className="marketing-img"><img src={seo13} alt="" /></div>
            </div>
            <div className="col seo-marketing-col">
            <div className="heading-content-seo-mar">
                        <h1>
                        Enhance Website Ranking
                        </h1>
                    </div>
                    <div className="side-para3">
                        <p>Improving your website's ranking on search engine results is critical to driving organic traffic. Interestingly, 60% of websites with poor user experience fail to attract organic traffic. At Raj Digital Marketing, we focus on optimizing the user experience to improve your website's ranking. Our SEO experts apply proven strategies to enhance website performance, user engagement, and site speed—ensuring your site not only ranks higher but also retains visitors longer. With a combination of technical SEO, content optimization, and site structure improvements, we help your website gain visibility, attract more organic traffic, and achieve sustained search engine ranking success.</p>
                        </div>
                        <div className="heading-button">
                        <div className="button-design-seo-mar">
                            <h4>View More</h4>
                        </div>
                    </div>
            </div>
            <div className="col seo-marketing-col">
            <div className="heading-content-seo-mar">
                        <h1>
                        Tracking Report
                        </h1>
                    </div>
                    <div className="side-para3">
                        <p>A comprehensive tracking report is essential for monitoring and evaluating your SEO performance. At Raj Digital Marketing, we provide in-depth tracking reports that allow you to assess the effectiveness of your SEO strategies. Our team continuously monitors your website’s performance, analyzes key metrics, and delivers actionable insights to keep your strategies on track. By regularly tracking your SEO progress, we ensure that your efforts are optimized for maximum results and that any necessary adjustments are made to maintain and improve your rankings.</p>
                        </div>
                        <div className="heading-button">
                        <div className="button-design-seo-mar">
                            <h4>View More</h4>
                        </div>
                    </div>
            </div>
            
            <div className="col seo-marketing-col">
                <div className="marketing-img"><img src={seo14} alt="" /></div>
            </div>
        </div>

      </div>

    </>
  )
}
